export const HANDSFREE_ONBOARDING_STORAGE_KEY =
  'theysaid_handsfree_onboarding_v1';

export type OnboardingCardPlacement = 'left' | 'right' | 'top' | 'bottom';

type HandsfreeOnboardingStepId =
  | 'taskPanel'
  | 'pauseTest'
  | 'nextQuestion'
  | 'primaryWindow'
  | 'reportProblem';

export type HandsfreeOnboardingStep = {
  id: HandsfreeOnboardingStepId;
  hasCloseLine: boolean;
  targetSelector: string;
  /** Optional second element to include in the same highlight (union bounding box). */
  additionalTargetSelector?: string;
  icon: 'check' | 'pause' | 'arrow' | 'monitor' | 'flag';
  placement: OnboardingCardPlacement;
};

export const HANDSFREE_ONBOARDING_CARD_GAP_PX = 16;

export const HANDSFREE_ONBOARDING_STEPS: readonly HandsfreeOnboardingStep[] = [
  {
    id: 'taskPanel',
    hasCloseLine: true,
    targetSelector: '[data-test="handsfree-task-panel"]',
    additionalTargetSelector: '[data-test="handsfree-progress-bars"]',
    icon: 'check',
    placement: 'left',
  },
  {
    id: 'pauseTest',
    hasCloseLine: true,
    targetSelector: '[data-test="handsfree-pause-resume-button"]',
    icon: 'pause',
    placement: 'top',
  },
  {
    id: 'nextQuestion',
    hasCloseLine: false,
    targetSelector: '[data-test="handsfree-say-next-pill"]',
    icon: 'arrow',
    placement: 'top',
  },
  {
    id: 'primaryWindow',
    hasCloseLine: false,
    targetSelector: '[data-test="usability-response-iframe-container"]',
    icon: 'monitor',
    placement: 'top',
  },
  {
    id: 'reportProblem',
    hasCloseLine: false,
    targetSelector:
      '[data-test="handsfree-task-panel"] [data-test="report-problem-trigger"]',
    icon: 'flag',
    placement: 'left',
  },
];

export const HANDSFREE_ONBOARDING_FIRST_MESSAGE_DELAY_MS = 500;
